import { useRequest } from '@polvo-labs/react-auth'
import React, { useRef, useState } from 'react'
import { FieldRenderProps } from 'react-final-form'
import { toast } from 'react-toastify'
import Button from '../../Button'
import { confirm } from '../../Dialog'
import Icon from '../../Icon'
import Loader from '../../Loader'
import { File, FileName } from './styles'
import { UploadData } from './type'


interface Props extends FieldRenderProps<any[], HTMLInputElement> {
  id: string
  data: UploadData
}

const Upload: React.FC<Props> = ({
  id,
  input,
  data
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [uploading, setUploading] = useState(false)
  const { request } = useRequest()

  const uploadFiles = (files: any[], input: any) => {
    setUploading(true)

    const formData = new FormData()
    files.forEach(file => {
      formData.append('files[]', file)
    })
    if (data.realty_id)
      formData.append('realty_id', data.realty_id)

    request({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/uploads`,
      data: formData,
    }).then(({ data }) => {
      toast.info('Upload realizado com sucesso')
      setUploading(false)
      if (data && data.data) {
        input.onChange([
          ...input.value,
          ...data.data,
        ])
      }
    }).catch(() => {
      toast.error('Ocorreu um erro ao fazer o upload')
      setUploading(false)
    })
  }

  const uploadFileEvent = (event: any) => {

    const files = Array.from(event.target.files as FileList)
    if (files.length > 0) {

      if (files.some(f => f.size > 20000000)) {
        toast.error('Arquivo não deve exceder 20MB de tamanho.')
        return
      }

      let filesSameName: File[] = []
      let filesWithoutSameName: File[] = files
      let message = 'Os seguintes arquivos já existem: '
      if (input.value) {
        input.value.forEach((uploadedFile: File) => {
          const repeated = files.find(f => f.name === uploadedFile.name)
          if (repeated) {
            if (!filesSameName.find(f => f.name === uploadedFile.name)) {
              filesSameName.push(repeated)
              message = `${message} ${repeated.name},`
            }
            const index = filesWithoutSameName.indexOf(repeated)
            filesWithoutSameName.splice(index, 1)
          }
        })
      }
      message = `${message} Deseja removê-los da lista?`
      if (filesSameName.length > 0) {
        confirm({
          title: 'Confirme',
          message: message,
          buttons: [
            {
              label: 'Sim',
              onClick: () => {
                if (filesWithoutSameName.length)
                  uploadFiles(filesWithoutSameName, input)
              }
            },
            {
              label: 'Não',
              onClick: () => {
                if(files.length)                
                uploadFiles(files, input)
              }
            }
          ]
        })
      } else {
        uploadFiles(files, input)
      }
    }
  }

  const handleClick = (event: any) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  return (
    <>
      <input
        id={id}
        ref={inputRef}
        type="file"
        onChange={uploadFileEvent}
        hidden
        multiple
        onClick={handleClick}
      />

      <span>
        {input.value && input.value.map(file => (
          <File
            key={file.id}
          >
            <Icon
              name="attachment"
            />

            <FileName
              href={file.url}
              target="_blank"
            >
              {file.name}
            </FileName>

            <Button
              label={(
                <Icon
                  name="delete"
                />
              )}
              backgroundColor="transparent"
              smallPadding
              onClick={() => {
                if (data.realty_id) {
                  request({
                    method: 'DELETE',
                    url: `${process.env.REACT_APP_API_URL}/uploads/${file.id}`,
                  }).then(({ data }) => {
                    setUploading(false)
                    const uploads = [...input.value].filter(u => u.id !== file.id)
                    input.onChange(uploads)
                  }).catch(() => {
                    toast.error('Ocorreu um erro')
                    setUploading(false)
                  })
                }
                else {
                  const uploads = [...input.value].filter(u => u.id !== file.id)
                  input.onChange(uploads)
                }
              }}
            />
          </File>
        ))}
      </span>

      <Button
        before={(
          <Icon
            name="attachment-blue"
          />
        )}
        label="Anexar arquivos"
        backgroundColor="lightBluishGray"
        fontColor="darkBlue"
        onClick={() => inputRef.current!.click()}
      />

      {uploading && (
        <Loader
          full
        />
      )}
    </>
  )
}

export default Upload
